import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateDiscordPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.createDiscordPerk,
  {
    mutationKey: ['createDiscordPerk'],
  },
)
